import { LanguageSelectOption } from "projects/pax-ui/components/uncontrolled-select/types/language-select-option.interface";

import { Language } from "./language.enum";

export const mobileLanguageMapping = new Map<keyof typeof Language, string>([
  ["DE", "Deutsch"],
  ["FR", "Français"],
  ["IT", "Italiano"],
]);

export function makeLanguageSelectOptions() {
  const array: LanguageSelectOption[] = [];
  mobileLanguageMapping.forEach((value, key) => {
    array.push({ value: Language[key], label: value, mobileLabel: key });
  });

  return array;
}
